import { Record as record } from 'immutable';
import Station from './Station';
import { resolve } from '../helpers/LinkMapper';

const SplitInfoRecord = record({
    splitId: '',
    splitSections: [],
    splitSaving: 0,
    outwardOrigin: new Station(),
    outwardDestination: new Station(),
    inwardOrigin: new Station(),
    inwardDestination: new Station(),
});

class SplitInfo extends SplitInfoRecord {
    static fromJSON(json = {}) {
        return new SplitInfo({
            splitId: json.splitId || '',
            splitSections: Array.isArray(json.splitSections) ? json.splitSections : [],
            splitSaving: typeof json.splitSaving === 'number' ? json.splitSaving : 0,
            outwardOrigin: resolve(json.outwardOrigin).as(Station) || new Station(),
            outwardDestination: resolve(json.outwardDestination).as(Station) || new Station(),
            inwardOrigin: json.inwardOrigin ? resolve(json.inwardOrigin).as(Station) : new Station(),
            inwardDestination: json.inwardDestination ? resolve(json.inwardDestination).as(Station) : new Station(),
        });
    }
}

export default SplitInfo;
